import { QtmProgressCircle } from '@qtm/react';

import './loader.css';

const Loader = () => {
  return (
    <div className="loader">
      <QtmProgressCircle track size="xlarge" />
    </div>
  );
};

export default Loader;
